/**
 * Constants et configurations pour SkyChart
 */

// Planet colours — the kawaii palette.
//
// These are painted on a CANVAS, where no stylesheet can reach them, so they have
// to live here. It is the one place in this theme where a colour is written outside
// base/_tokens.scss — and also the reason a wheel copied over from another theme
// drops an object of a foreign palette in the middle of a cream page.
//
// The tokens are pastel because they sit on cream; a filled disc carrying a glyph
// needs more weight than that. Each colour below is the DEEP form of a token hue
// (fox, lilac, sky, blush, coral, honey, mint, leaf, cocoa ink) — same family,
// enough value to keep a white glyph readable and to tell twelve discs apart.
export const PLANET_COLORS = {
    'SUN': '#d85f28',        // fox, deep — the theme's signature carries the Sun
    'MOON': '#8f7ac4',       // lilac, deep
    'MERCURY': '#3f86c4',    // sky, deep
    'VENUS': '#d4657a',      // blush, deep
    'MARS': '#d6414f',       // coral, deep
    'JUPITER': '#c98a1e',    // honey, deep
    'SATURN': '#8a6a55',     // cocoa, soft
    'URANUS': '#2fa891',     // mint, deep
    'NEPTUNE': '#2f6ea8',    // sky, deeper
    'PLUTO': '#4a3428',      // cocoa ink
    'NORTH_NODE': '#2f9a72', // leaf, deep
    'BLACK_MOON': '#3a2820'  // ink, strong
};

// Aspect styling — same palette, the colour carrying the meaning: harmony in the
// greens, tension in coral, everything else in a quieter hue.
export const ASPECT_CONFIG = {
    // Aspects majeurs
    'CONJUNCTION': { color: '#8f7ac4', width: 2.0, dash: [] },            // lilac
    'OPPOSITION': { color: '#d6414f', width: 2.0, dash: [] },             // coral
    'TRINE': { color: '#2f9a72', width: 1.8, dash: [] },                  // leaf
    'SQUARE': { color: '#d6414f', width: 1.8, dash: [5, 3] },             // coral, dashed
    'SEXTILE': { color: '#2f9a72', width: 1.5, dash: [5, 3] },            // leaf, dashed

    // Aspects mineurs
    'SEMISEXTILE': { color: '#3f86c4', width: 0.8, dash: [5, 3] },        // sky
    'QUINCUNX': { color: '#c98a1e', width: 1.2, dash: [5, 3] },           // honey
    'SEMISQUARE': { color: '#d6414f', width: 1.0, dash: [2, 2] },         // coral
    'SESQUISQUARE': { color: '#d6414f', width: 1.0, dash: [2, 2, 5, 2] }, // coral

    // Aspects harmoniques
    'QUINTILE': { color: '#c98a1e', width: 0.8, dash: [5, 3] },           // honey
    'BIQUINTILE': { color: '#c98a1e', width: 0.8, dash: [5, 3] },         // honey
    'SEPTILE': { color: '#2fa891', width: 0.6, dash: [1, 3] },            // mint
    'NOVILE': { color: '#2fa891', width: 0.6, dash: [1, 2] }             // mint
};

// Tables de conversion
export const SIGN_START_DEGREE = {
    'ARIES': 0, 'TAURUS': 30, 'GEMINI': 60, 'CANCER': 90,
    'LEO': 120, 'VIRGO': 150, 'LIBRA': 180, 'SCORPIO': 210,
    'SAGITTARIUS': 240, 'CAPRICORN': 270, 'AQUARIUS': 300, 'PISCES': 330
};

export const PLANET_SYMBOLS = {
    'SUN': '☉', 'MOON': '☽', 'MERCURY': '☿', 'VENUS': '♀', 'MARS': '♂',
    'JUPITER': '♃', 'SATURN': '♄', 'URANUS': '♅', 'NEPTUNE': '♆',
    'PLUTO': '♇', 'NORTH_NODE': '☊', 'BLACK_MOON': '⚸'
};

// Distances relatives des planètes pour leur positionnement
export const PLANET_DISTANCES = {
    'SUN': 0.45, 'MOON': 0.0078125, 'MERCURY': 0.27, 'VENUS': 0.09,
    'MARS': 0.18, 'JUPITER': 0.54, 'SATURN': 0.63,
    'URANUS': 0.72, 'NEPTUNE': 0.81, 'PLUTO': 0.9,
    'NORTH_NODE': 1.0, 'BLACK_MOON': 0.0078125
};

// Options par défaut
export const DEFAULT_OPTIONS = {
    margin: 20,
    zodiacWidth: 0.15,  // % du rayon
    innerRadius: 0.4,   // % du rayon pour le cercle intérieur
    planetRadius: 0.85  // % du rayon pour les planètes
};